import React, { useState } from "react";
import {
  withStyles,
  Typography,
  IconButton,
  Container,
  Card,
  Box,
  Button,
  Tooltip,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Alert } from "@material-ui/lab";
import { useHubx } from "../../HubX";
import useConstructor from "../../core/hooks/useConstructor";
import { FETCH_BUSINESS_EVENT_BY_ID } from "../../Fedx";
import BusinessEvent from "../../core/models/BusinessEvent";
import {
  Workflow,
  WorkflowTypes,
  WorkflowMessage,
  PRAGAS_DESCARGA_ZERO,
} from "../../core/models/Enum/Workflow";
import { formatValueWithCurrency, castNumberTo2Decimals, formatValue } from "../../helpers/utility";
import { useHistory } from "react-router-dom";
import SimpleLink from "../SimpleLink";
import NavigateIcon from "../../assets/icons/NavigateIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { color } from "highcharts";

const WhiteTextTypography = withStyles({
  root: {
    color: "#FFFFFF",
  },
})(Typography);

type EventComponentProps = {
  // header: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  businessEvent_id: number;
  loading?: boolean;
};

const headerArray = [
  "Pedido",
  "Cliente",
  "Data de Abertura",
  "Último status",
  "Aberto/Fechado",
  "Tipo",
  "Detalhes",
];

const loadingState = new Array(12).fill({});

// const history = useHistory();

// loading shouldnt be false
function EventComponent({ businessEvent_id, loading = false }: EventComponentProps) {
  const hub = useHubx();
  const history = useHistory();

  const [businessEvent, setBusinessEvent] = useState<BusinessEvent>();
  const idClient = businessEvent?.codigo_li == null ? "Código JDE" : "Código LI"
  const headerCliente: string[] = [
    "Cliente",
    "N° White",
    idClient,
    "Classificação",
    "Unidade Responsável",
    "Produto",
  ];

  const detailsCliente: string[] = businessEvent
    ? [
      (businessEvent.cliente != null ? businessEvent.cliente?.nome_fantasia : businessEvent.cliente_sap?.nome_fantasia) ?? "-",
      businessEvent.numero_white ?? "",
      (businessEvent.codigo_li == null ? businessEvent.numero_jde : businessEvent.codigo_li) ?? "",
      (businessEvent.cliente != null ? businessEvent.cliente?.desc_classificacao : businessEvent.cliente_sap?.desc_classificacao) ?? "-",
      (businessEvent.cliente != null ? businessEvent.cliente?.unidade_responsavel : businessEvent.cliente_sap?.unidade_responsavel) ?? "-",
      businessEvent.codigo_produto ?? "",
    ].map((x) => x.toString())
    : [];

  const descargaZeroHeader: string[] = [
    "Número da viagem",
    "Chegada",
    "Saída",
    "CDL Responsável",
    "Custo para o cliente",
    "Motivo da descarga zero",
    "Justificativa do motorista",
  ];
  const restriçãoDeVolumeHeader: string[] = [
    "Número da viagem",
    "Chegada",
    "Saída",
    "CDL Responsável",
    "Custo para o cliente",
    "Permanência",
    "Planejado (m³/Kg)",
    "Realizado (m³/Kg)",
    "Nível após entrega (m³/Kg)",
    "Capacidade instalada (m³/Kg)",
    "Justificativa do motorista",
  ];
  const retençãoHeader: string[] = [
    "Número da viagem",
    "Chegada",
    "Saída",
    "CDL Responsável",
    "Realizado (Kg)",
    "Custo para o cliente",
    "Custo por hora",
    "Permanência",
    "Baseline",
    "Retenção",
    "Retenção cobrança",
  ];

  const retencaoComplementoHeader: string[] = [
    "Culpado",
    "Motivo Retenção",
    "Justificativa do motorista",
  ];

  const retencaoComplementoDetails: string[] = businessEvent
  ? [
    businessEvent.culpado ?? "N/A",
    businessEvent.motivo ?? "N/A",
    businessEvent.explicacao_motorista ?? "N/A",
  ].map((x) => x.toString())
  : [];

  const pedidoLiqHeader: string[] = [
    "Número da viagem",
    "Chegada",
    "Saída",
    "CDL Responsável",
    "Custo para o cliente",
    "Data de entrada do pedido",
    "Data prometida de entrega",
    "Forma de contato",
  ];

  const descargaZeroDetails: string[] = businessEvent
    ? [
      businessEvent.numero_viagem ?? "",
      businessEvent.dt_protocolo_chegada_viagem_formatted ?? "",
      businessEvent.dt_protocolo_saida_viagem_formatted ?? "",
      businessEvent.unidade_distribuicao ?? "",
      formatValueWithCurrency(businessEvent.taxa.valor ?? 0),
      businessEvent.status_ordem_entrega ?? "",
      businessEvent.explicacao_motorista ?? "",
    ].map((x) => x.toString())
    : [];

  const restriçãoDeVolumeDetails: string[] = businessEvent
    ? [
      businessEvent.numero_viagem ?? "",
      businessEvent.dt_protocolo_chegada_viagem_formatted ?? "",
      businessEvent.dt_protocolo_saida_viagem_formatted ?? "",
      businessEvent.unidade_distribuicao ?? "",
      formatValueWithCurrency(businessEvent.taxa.valor ?? 0),
      castNumberTo2Decimals(businessEvent.duracao) + " min" ?? "",
      formatValue(businessEvent.volume_m3_planejado) ?? "",
      formatValue(businessEvent.volume_m3_atual) ?? "",
      formatValue(businessEvent.nivel_apos_entrega_su) ?? "",
      formatValue(businessEvent.capacidade_instalacao_su) ?? "",
      businessEvent.explicacao_motorista ?? "",
    ].map((x) => x.toString())
    : [];

  const volume_ton_atual = businessEvent?.volume_kg_atual ? businessEvent.volume_kg_atual/1000 : 0

  const retençãoDetails: string[] = businessEvent
    ? [
      businessEvent.numero_viagem ?? "",
      businessEvent.dt_protocolo_chegada_viagem_formatted ?? "",
      businessEvent.dt_protocolo_saida_viagem_formatted ?? "",
      businessEvent.unidade_distribuicao ?? "",
      businessEvent.volume_kg_atual ?? "",
      formatValueWithCurrency(
        businessEvent.taxa.valor * businessEvent.retencao_cobranca ?? 0
      ),
      formatValueWithCurrency(businessEvent.taxa.valor ?? 0),
      castNumberTo2Decimals(businessEvent.duracao_protocolo_viagem) + " min" ?? "",
      formatValue(businessEvent.baseline_constante + 
        (businessEvent.baseline_variavel * volume_ton_atual)) + " min" ?? "",
      formatValue(businessEvent.retencao_util) + " min" ?? "",
      businessEvent.retencao_cobranca + "h" ?? "",
      businessEvent.explicacao_motorista ?? "",
    ].map((x) => x.toString())
    : [];

    const retencaoFormulaTooltip=`
    [Baseline] = [Setup] + [Variável] x [Tonelada Abastecida]
    `;
    const retencaoTooltip = `Setup = ${formatValue(businessEvent?.baseline_constante, 2)} min 
    Variável = ${formatValue(businessEvent?.baseline_variavel, 2)} min/ton
    Tonelada Abastecida = ${formatValue(volume_ton_atual, 3)} ton
    `;

  const pedidoLiqDetails: string[] = businessEvent
    ? [
      businessEvent.numero_viagem ?? "",
      businessEvent.dt_protocolo_chegada_viagem_formatted ?? "",
      businessEvent.dt_protocolo_saida_viagem_formatted ?? "",
      businessEvent.unidade_distribuicao ?? "",
      formatValueWithCurrency(businessEvent.taxa.valor ?? 0),
      businessEvent.dt_contato_central_formatted ?? "",
      businessEvent.dt_end_pedido_formatted ?? "",
      businessEvent.forma_contato ?? "",
    ].map((x) => x.toString())
    : [];

  useConstructor(async () => {
    const businessEvent = await hub.request(FETCH_BUSINESS_EVENT_BY_ID, businessEvent_id);
    setBusinessEvent(businessEvent);
  });

  return (
    <Container maxWidth={"xl"}>
      {businessEvent?.tipo_workflow !== null &&
        businessEvent?.tipo_workflow !== undefined && (
          <Typography component="h1" variant="h5" color="textSecondary">
            Evento #{businessEvent?.id} |{" "}
            {Workflow[businessEvent?.tipo_workflow]}
          </Typography>
        )}

      <Button variant="text" onClick={() => history.push("/home/")}>
        <NavigateIcon transform="rotate(-180)" />
        Voltar
      </Button>

      <Card>
        <div>
          <Box p={1} flexGrow={1} bgcolor="#6B717F">
            <WhiteTextTypography>Dados do Evento</WhiteTextTypography>
          </Box>
        </div>
        {businessEvent?.tipo_workflow !== null &&
          businessEvent?.tipo_workflow !== undefined &&
          businessEvent?.tipo_workflow != PRAGAS_DESCARGA_ZERO && (
            <Alert
              severity="error"
              style={{ background: "transparent", color: "#E1000F", fontStyle: "italic" }}
            >
              {WorkflowMessage[businessEvent?.tipo_workflow]}
            </Alert>
          )}
        <div style={{ width: "100%" }}>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            p={1}
            m={1}
            bgcolor="background.paper"
          >
            <b>Cliente</b>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            p={0}
            m={0}
            bgcolor="background.paper"
          >
            {headerCliente.map((header, idx) => (
              <Box key={idx} flexDirection="column" p={1} m={1}>
                <Box p={0} fontSize="small" color="#606060">
                  {header}
                </Box>
                <Box p={0}>{detailsCliente[idx]}</Box>
              </Box>
            ))}
          </Box>

          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            p={1}
            m={1}
            bgcolor="background.paper"
          >
            <b>Evento</b>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            p={0}
            m={0}
            bgcolor="background.paper"
          >
            {businessEvent?.tipo_workflow == WorkflowTypes.PRAGAS_DESCARGA_ZERO &&
              descargaZeroHeader.map((header, idx) => (
                <Box key={idx} flexDirection="column" p={1} m={1}>
                  <Box p={0} fontSize="small" color="#606060">
                    {header}
                  </Box>
                  <Box p={0}>{descargaZeroDetails[idx]}</Box>
                </Box>
              ))}
            {businessEvent?.tipo_workflow ==
              WorkflowTypes.PRAGAS_RESTRICAO_VOLUME &&
              restriçãoDeVolumeHeader.map((header, idx) => (
                <Box key={idx} flexDirection="column" p={1} m={1}>
                  <Box p={0} fontSize="small" color="#606060">
                    {header}
                  </Box>
                  <Box p={0}>{restriçãoDeVolumeDetails[idx]}</Box>
                </Box>
              ))}
            {businessEvent?.tipo_workflow ==
              WorkflowTypes.PRAGAS_RETENCAO_ALEM_DO_TEMPO &&
              retençãoHeader.map((header, idx) => (
                header === 'Baseline' ? (
                  
                    <Box flexDirection="column" p={1} m={1}>
                      <Box p={0} fontSize="small" color="#606060">
                        {header} 
                        <Tooltip placement="top" title={<span style={{ whiteSpace: 'pre-line', fontSize: 'smaller'  }}>
                           <span style={{ fontWeight: 'bold', whiteSpace: 'nowrap', fontSize: 'small' }}>Racional de Cálculo</span>
                           <span style={{ lineHeight:'3' }}>{retencaoFormulaTooltip}</span>
                           {retencaoTooltip}</span>} key={idx}>
                          <FontAwesomeIcon color="#236374" pull="right" icon={faCircleInfo} />
                        </Tooltip>
                      </Box>
                      <Box p={0}>{retençãoDetails[idx]}</Box>
                    </Box>
                ) : (
                  <Box key={idx} flexDirection="column" p={1} m={1}>
                    <Box p={0} fontSize="small" color="#606060">
                      {header}
                    </Box>
                    <Box p={0}>{retençãoDetails[idx]}</Box>
                  </Box>
                )
              ))}
            {businessEvent?.tipo_workflow ==
              WorkflowTypes.SIEBEL_PEDIDO_LIQUIDO_FORA_DO_PRAZO &&
              pedidoLiqHeader.map((header, idx) => (
                <Box key={idx} flexDirection="column" p={1} m={1}>
                  <Box p={0} fontSize="small" color="#606060">
                    {header}
                  </Box>
                  <Box p={0}>{pedidoLiqDetails[idx]}</Box>
                </Box>
              ))}
          </Box>
          {businessEvent?.tipo_workflow == WorkflowTypes.PRAGAS_RETENCAO_ALEM_DO_TEMPO ? (
          <Box
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            p={0}
            m={0}
            bgcolor="background.paper"
          >
            {retencaoComplementoHeader.map((header, idx) => (
              <Box key={idx} flexDirection="column" p={1} m={1} marginRight={8}>
                <Box p={0} fontSize="small" color="#606060">
                  {header}
                </Box>
                {header === "Motivo Retenção" && retencaoComplementoDetails[idx] ? (
                  retencaoComplementoDetails[idx].split(';').map((item, i, arr) => (
                    item.trim() ? (
                      <Box key={i} p={0}>
                        &bull; {item}
                      </Box>
                    ) : ""
                  ))
                ) : (
                  <Box p={0}>{retencaoComplementoDetails[idx]}</Box>
                )}
              </Box>
            ))}
          </Box>) : null}

        </div>
      </Card>
    </Container>
  );
}
export default EventComponent;
